import { Play } from "lucide-react";
import { useTranslate } from "ra-core";
import { buttonVariants } from "@/components/ui/button";
import { cn } from "@/lib/utils";

import { playableUrl } from "./callFormat";

/**
 * «Слушать»: the PBX's record opens in a new tab. Only web links (http,
 * https) are shown; the CRM keeps no copy yet (calls.record_path is for later).
 */
export const CallPlayer = ({ url }: { url?: string | null }) => {
  const translate = useTranslate();
  const href = playableUrl(url);
  if (!href) return null;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={cn(
        buttonVariants({ variant: "ghost", size: "sm" }),
        "h-7 px-2",
      )}
    >
      <Play className="size-3.5" />
      {translate("crm.calls.listen")}
    </a>
  );
};
